import React from 'react';
import { RemoveIconBig } from 'components/common/icons';
import { Col, FMGModal, Row, Typography } from 'components';
import { useRemoveBrandModal } from './useRemoveBrandModal';

const { Text } = Typography;

export interface RemoveBrandModal {
  openModal: boolean;
  recordId: string | undefined;
  onCancelModal: () => void;
}

export const RemoveBrandModal = (props: RemoveBrandModal) => {
  const { openModal, onCancelModal, recordId } = props;
  const { onFinish, isLoading, onCancel } = useRemoveBrandModal({ onCancelModal, recordId });
  return (
    <FMGModal
      isLoading={isLoading}
      open={openModal}
      onSubmit={onFinish}
      onCancel={onCancel}
      width={360}
      okText={'Remove'}
    >
      <Row align={'middle'} gutter={[0, 12]} justify={'center'} className={'margin-t-20'}>
        <RemoveIconBig />
        <Col span={24} className={'center'}>
          <Text className={'font-size-24 font-weight-800'}>Remove Brand</Text>
        </Col>
        <Text type={'secondary'}>Are you sure you want to remove this Brand?</Text>
      </Row>
    </FMGModal>
  );
};
